export const statusDesc = ['待处理', '已同意', '已拒绝', '已撤回', '已撤回','已作废'];
export const operateTypes = ['发起申请','审批通过','审批驳回','学员撤回申请','系统自动撤回申请','请假作废'];    
      
